import React, { useEffect } from "react";
import * as s from "./ClientsComponent.styles";

import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";

// components
import ClientsControls from "./clientsControls/ClientsControls";

const ClientsComponent = (props) => {
  const { showCreateClient } = props;

  const loading = useSelector((state) => state.forClients.loading);

  const clients = useSelector((state) => state.forClients.users);
  // console.log(props);
  // console.log(clients);
  return (
    <s.Container>
      <s.LeadContainer>
        <s.Lead>Clients</s.Lead>
        {showCreateClient && (
          <s.CreateBtn
            onClick={() => {
              props.history.push("/create-client");
            }}
          >
            Create New One
          </s.CreateBtn>
        )}
      </s.LeadContainer>
      <s.ClientsContainer>
        {loading === false && <ClientsControls clients={clients} />}
      </s.ClientsContainer>
    </s.Container>
  );
};

export default withRouter(ClientsComponent);
